<template>
	<v-app  >
        <navigation></navigation>
        <v-toolbar color="blue darken-3" app sticky clipped-left>
            <v-toolbar-side-icon class="white--text" @click="clickBurger"></v-toolbar-side-icon>
            <span class="title ml-3 mr-5"><span class="black--text">SGCC </span> <span class="font-weight-light white--text ">Payslip</span></span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-content>
            <v-container fluid fill-height class="grey lighten-5 black--text">
                <v-layout>
                    <router-view />
                </v-layout>
            </v-container>
        </v-content>



        <v-dialog
            v-model="globalLoaderModel"
            persistent
            width="300"
        >
            <v-card color="primary" dark>
            <v-card-text>
                Please stand by
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
            </v-card>
        </v-dialog>

        <force-password></force-password>
    </v-app>
</template>

<script>
import VueCookies from 'vue-cookies';
import navigation from '../components/navigation.vue';
import forcePassword from '../components/users/forcePassword.vue';

export default {

    mounted : function(){
        this.setCookieDataUser();
    },

    components : {
        'navigation' : navigation,
        'force-password' : forcePassword
    },

	created : function(){
        this.eventHub.$on('openGlobalLoaderModal', () => {
            this.globalLoaderModel = true;
        });

        this.eventHub.$on('closeGlobalLoaderModal', () => {
            this.globalLoaderModel = false;
        });

        this.setCookieDataUser();
	},

	data () {
        return {
            drawer: true,
            globalLoaderModel : false
        }
    },

	methods : {
		clickBurger : function(){
            this.eventHub.$emit("clickBurgerNav");
        },

        setCookieDataUser : function(){
            let cookie = VueCookies.get(this.cookieKey);
            if(cookie != null){
                this.userRoles = cookie.data.roles;
                this.userData = JSON.parse( JSON.stringify(cookie.data.user) );
            }
        }
	}

};
</script>

<style>
    
    table thead tr th:not(:last-child),
    table tbody tr td:not(:last-child){
        border-right: 1px solid rgb(221, 221, 221);
    }

    table thead tr th,
    table tbody tr td{
        border-bottom: 1px solid rgb(221, 221, 221);
    }

</style>